export const SKILLS = {
  frontend: "Frontend",
  backend: "Backend",
  mobile: "Mobile",
  lowCode: "Low Code",
  testing: "Testing",
  deployment: "Deployment",
  communication: "Communication",
} as const;
